<script setup lang="ts">
import GlobalLoader from '@/components/GlobalLoader.vue';
</script>
<template><GlobalLoader/><router-view /></template>
